import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SendBlankIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SendBlankIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SendBlankIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SendBlankIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SendBlankIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M1.241 1.405A2 2 0 013.812.53l.14.07 17.801 9.641a2 2 0 01.135 3.438l-.135.08-17.8 9.642a2 2 0 01-2.948-1.61L1 21.642V15l6-3-6-3V2.358a2 2 0 01.241-.953zM3 2.358v5.406L11.472 12 3 16.235v5.406L20.799 12 3 2.358z"
        fillRule="evenodd"
      />
    </svg>
  )
);
SendBlankIcon.displayName = "SendBlankIcon";
export default SendBlankIcon;
